var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap-empty-nticket"},[_c('div',{staticClass:"image-empty"}),_c('div',{staticClass:"text-empty-nticket"},[_vm._v(_vm._s(_vm.$t('no_default_list')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }